/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/headerCumbs.scss';

import React, {Fragment} from 'react';
import {HeaderCrumb} from "../../../util/interfaces";
import {PureComponent} from "react";
import {CustomAppEvent, navigate, voidFunction, WithEvents} from '@dvrd/dvr-controls';
import classNames from 'classnames';

interface State {
    crumbs: HeaderCrumb[];
}

export default class HeaderCrumbs extends PureComponent<any, State> {
    private readonly event: CustomAppEvent;

    constructor(props: any) {
        super(props);
        this.event = {eventName: 'onSetCrumbs', handler: this.onSetCrumbs};
        this.state = {
            crumbs: [],
        };
    };

    onClickCrumb = (crumb: HeaderCrumb) => () => {
        if (crumb.route) navigate(crumb.route);
    }

    onSetCrumbs = (crumbs: HeaderCrumb[]) => {
        this.setState({crumbs});
    };

    renderCrumb = (crumb: HeaderCrumb, index: number, total: number) => {
        const clickable = index < total - 1 && crumb.route !== undefined;
        return (
            <Fragment key={index}>
                <h1 className={classNames('crumb', clickable && 'active')}
                    onClick={clickable ? this.onClickCrumb(crumb) : voidFunction}>{crumb.label}</h1>
                {index < total - 1 && <span className='arr'>&nbsp;{'>'}&nbsp;</span>}
            </Fragment>
        );
    };

    render = () => {
        const {crumbs} = this.state, count = crumbs.length;
        return (
            <WithEvents events={this.event}>
                <div className='crumbs'>
                    {crumbs.map((crumb: HeaderCrumb, index: number) => this.renderCrumb(crumb, index, count))}
                </div>
            </WithEvents>
        )
    }
}